import JSZip from "jszip";
import Constants from '../config/constants';
import { saveAs } from 'file-saver';
import { digest } from '../utils/util';

export const getFileContentsAsDataUrl = (file) =>
    new Promise((resolve, reject) =>
        getFileContents(resolve, reject)
            .readAsDataURL(file));

export const getFileContentsAsText = (file) =>
    new Promise((resolve, reject) =>
        getFileContents(resolve, reject)
            .readAsText(file));

export const resolveZipName = (filename, fallback = "archive") =>
    resolveFilename(filename, fallback) + '.zip';

export const resolveCsvName = (filename, fallback = "data") =>
    resolveFilename(filename, fallback) + '.csv';

const resolveFilename = (filename, fallback = "archive") =>
    ((filename.match(/(.*?)[_|-]\{.*/s) || [])[1] || fallback);

export const handleZipDownload = (results, filename = "certificates.zip") => {
    const zip = new JSZip();

    results
        .flatMap(r => r)
        .forEach(r => zip.file(r.filename, r.content, { base64: true }));

    zip
        .generateAsync({ type: "blob" })
        .then(c => saveAs(c, filename));
};

export const handleCsvDownload = (results, filename = "certificates.csv") => {
    let certificatesCsv = results.reduce((acc, certificate) => {
        const { artistName, link } = certificate
        acc.push([artistName, link].join(','))
        return acc
    }, []);

    const data = certificatesCsv.join('\n');

    const blob = new Blob([data], { type: 'text/csv' });

    saveAs(blob, filename);
};

export const uploadMissingFiles = async (service, files) => {
    const images = await Promise.all(files
        .map(async i => {
            return {
                filename: await digest(i.content),
                content: i.content
            }
        }));

    const digests = images
        .map(i => {
            return {
                filename: i.filename
            }
        });

    const existing = await service
        .checkMany(digests);

    const missing = images
        .filter(i => !existing.find(e => e.filename === i.filename))
        .flatMap(partitionBigImages)
        .map(m => service
            .uploadMany([m]));

    await Promise.all(missing);
}

const partitionBigImages = (image) => {
    if (image.content.length < Constants.MAX_POST_REQUEST_SIZE_IN_BYTES) {
        return [image];
    }

    const parts = [];
    const partitions = Math.ceil(image.content.length / Constants.MAX_POST_REQUEST_SIZE_IN_BYTES);

    for (let i = 0; i < partitions; i++) {
        parts.push({
            filename: i === 0 ? image.filename : `${image.filename}.${String(i).padStart(4, '0')}`,
            content: image.content.slice(Constants.MAX_POST_REQUEST_SIZE_IN_BYTES * i, Constants.MAX_POST_REQUEST_SIZE_IN_BYTES * (i + 1))
        });
    }

    return parts;
}

const getFileContents = (resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = (e) => resolve(e.target.result);
    reader.onerror = (e) => reject(e);

    return reader;
}